export const eventTypes = {
    ACCESS_REQUEST_CHANGED: 'ACCESS_REQUEST_CHANGED',
    QUOTE_STATUS_CHANGED: 'QUOTE_STATUS_CHANGED',
    NEW_QUOTE_MESSAGE: 'NEW_QUOTE_MESSAGE'
}